import React from 'react';
import { Link } from 'react-router-dom';
import { Order } from '../../types';

interface OrderCardProps {
  order: Order;
}

const OrderCard: React.FC<OrderCardProps> = ({ order }) => {
  const getStatusStyles = (status: string) => {
    switch (status.toLowerCase()) {
      case 'pending':
        return {
          border: 'border-yellow-500',
          bg: 'bg-yellow-100',
          text: 'text-yellow-700',
          actionText: 'Track Order',
          actionStyle: 'bg-yellow-500 hover:bg-yellow-600',
        };
      case 'processing':
        return {
          border: 'border-blue-500',
          bg: 'bg-blue-100',
          text: 'text-blue-700',
          actionText: 'Track Order',
          actionStyle: 'bg-blue-500 hover:bg-blue-600',
        };
      case 'confirmed':
        return {
          border: 'border-indigo-500',
          bg: 'bg-indigo-100',
          text: 'text-indigo-700',
          actionText: 'Track Order',
          actionStyle: 'bg-indigo-500 hover:bg-indigo-600',
        };
      case 'shipped':
        return {
          border: 'border-cyan-500',
          bg: 'bg-cyan-100',
          text: 'text-cyan-700',
          actionText: 'Track Shipment',
          actionStyle: 'bg-cyan-500 hover:bg-cyan-600',
        };
      case 'delivered':
        return {
          border: 'border-green-500',
          bg: 'bg-green-100',
          text: 'text-green-700',
          actionText: 'View Details',
          actionStyle: 'bg-green-500 hover:bg-green-600',
        };
      case 'cancelled':
        return {
          border: 'border-red-500',
          bg: 'bg-red-100',
          text: 'text-red-700',
          actionText: 'Contact Support',
          actionStyle: 'bg-red-500 hover:bg-red-600',
        };
      default:
        return {
          border: 'border-neutral-300',
          bg: 'bg-neutral-100',
          text: 'text-neutral-600',
          actionText: 'View Details',
          actionStyle: 'bg-neutral-500 hover:bg-neutral-600',
        };
    }
  };

  const styles = getStatusStyles(order.status);

  return (
    <div
      className={`border-l-4 ${styles.border} ${styles.bg} rounded-xl p-5 shadow-sm hover:shadow-md transition-all duration-200`}
    >
      <div className="flex flex-col sm:flex-row justify-between gap-4 items-start sm:items-center">
        <div className="space-y-1">
          <h3 className="text-lg font-semibold text-neutral-900">
            Order #{order.id}
          </h3>
          <p className="text-sm text-neutral-600">
            Placed on: {new Date(order.created_at).toLocaleDateString()}
          </p>
          <p className="text-sm text-neutral-600">Total: ${order.total}</p>
          <p className={`text-sm font-medium ${styles.text}`}>
            Status: {order.status}
          </p>

          {/* Shipping Preview */}
          <div className="mt-2 text-sm text-neutral-700 space-y-1">
            {order.address?.center && (
              <p>
                <span className="font-medium">Shipping:</span>{' '}
                {order.payment_method}
              </p>
            )}
          
            {order.address?.compound && (
              <p>
                <span className="font-medium">Mobile:</span>{' '}
                {order.address.mobile}
              </p>
            )}
          </div>
        </div>

        <Link
          to={`/orders/${order.id}`}
          className={`px-4 py-2 rounded-md text-white font-medium ${styles.actionStyle} transition-all`}
        >
          {styles.actionText}
        </Link>
      </div>
    </div>
  );
};

export default OrderCard;
